import axios from 'axios';

import { config } from '../config';
import { getAuthorizationBearerHeader } from '../utills/get-authorization-bearer-header';

export const getPaymentStatus = (paymentId) =>
    axios.get(config.endpoints.shop.paymentStatus(paymentId), {
        headers: { ...getAuthorizationBearerHeader() },
    });
